(() => {
  document.documentElement.classList.add('js');

  const initDashboard = (root) => {
    if (!root || root.dataset.bfInitialized === 'true') return;

    const bars = root.querySelectorAll('[data-bf-bar]');
    if (!bars.length) return;

    root.dataset.bfInitialized = 'true';

    if (!('IntersectionObserver' in window)) {
      bars.forEach((bar) => bar.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target
            .querySelectorAll('[data-bf-bar]')
            .forEach((bar) => bar.classList.add('is-visible'));

          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.22
      }
    );

    observer.observe(root);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-bf-dashboard]').forEach(initDashboard);
  };

  const onReady = () => initAll(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest?.('[data-bf-dashboard]');
    if (root) {
      root.querySelectorAll('[data-bf-bar]').forEach((bar) => {
        bar.classList.add('is-visible');
      });
    }
  });
})();
